// @flow

import { css } from 'styled-components'
import { deviceSizes } from 'frontend_core/dist/styles/variables'

// Iterate through the sizes and create a media template
export const mediaMax = Object.keys(deviceSizes).reduce((argsAcc, label) => {
  const acc = Object.assign({}, argsAcc)
  acc[label] = (...args) => css`
    @media (max-width: ${deviceSizes[label] - 1}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export const mediaMin = Object.keys(deviceSizes).reduce((argsAcc, label) => {
  const acc = Object.assign({}, argsAcc)
  acc[label] = (...args) => css`
    @media (min-width: ${deviceSizes[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

export const mediaOn = Object.keys(deviceSizes).reduce((argsAcc, label, i) => {
  const acc = Object.assign({}, argsAcc)
  const nextLabel = Object.keys(deviceSizes)[i + 1]

  acc[label] = (...args) => css`
    @media (min-width: ${deviceSizes[nextLabel] ||
        0}px) and (max-width: ${deviceSizes[label] - 1}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})
